import { TypePolicies } from '@apollo/client';

const CAPAQuotationUserRfqDetailOutputCache: TypePolicies = {
  CAPAQuotationUserRfqDetailOutput: {
    merge(existing, incoming, { mergeObjects }) {
      return mergeObjects(existing, incoming);
    }
  }
};

export default CAPAQuotationUserRfqDetailOutputCache;
